"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPrototypeImports = void 0;
var AutoModuleHardware_1 = require("../autoModule/AutoModuleHardware");
var Arrays_1 = require("@microchip/scf-device/lib/util/Arrays");
var createPrototypeImports = function (state, creatorFunctions, config) {
    var _a, _b, _c;
    var prototypeImports = {};
    config = (_a = creatorFunctions.getModuleConfig) === null || _a === void 0 ? void 0 : _a.call(creatorFunctions);
    if (!config)
        return prototypeImports;
    if (config === null || config === void 0 ? void 0 : config.peripherals) {
        config.peripherals.forEach(function (peripheral) {
            var _a;
            var interfaceName = getFriendlyInterfaceId(peripheral.interfaceId.name);
            var prototypeImport = (0, AutoModuleHardware_1.createPrototypeImport)(interfaceName, config);
            if (prototypeImport) {
                prototypeImports = __assign(__assign({}, prototypeImports), (_a = {}, _a[interfaceName] = __assign(__assign({}, prototypeImport), { isRequired: true }), _a));
            }
        });
    }
    (_c = (0, Arrays_1.getKeys)((_b = config === null || config === void 0 ? void 0 : config.imports) !== null && _b !== void 0 ? _b : {})) === null || _c === void 0 ? void 0 : _c.forEach(function (key) {
        var _a;
        var _b, _c, _d;
        var imp = (_b = config === null || config === void 0 ? void 0 : config.imports) === null || _b === void 0 ? void 0 : _b[key];
        var args = (_c = creatorFunctions === null || creatorFunctions === void 0 ? void 0 : creatorFunctions.getCreatorImportArgs) === null || _c === void 0 ? void 0 : _c.call(creatorFunctions, key, state);
        if (imp && ((_d = creatorFunctions === null || creatorFunctions === void 0 ? void 0 : creatorFunctions.shouldImport) === null || _d === void 0 ? void 0 : _d.call(creatorFunctions, key, state)) != false) {
            prototypeImports = __assign(__assign({}, prototypeImports), (_a = {}, _a[key] = __assign(__assign({}, imp.import), { args: args }), _a));
        }
    });
    return prototypeImports;
};
exports.createPrototypeImports = createPrototypeImports;
var getFriendlyInterfaceId = function (interfaceName) {
    interfaceName = interfaceName.replace(/ /g, "").replace(/-/g, "_");
    return interfaceName;
};
//# sourceMappingURL=createPrototypeImports.js.map